import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { SelectField } from "../../../core/select-field.component";
import { Form, Formik } from "formik";
import { useGetProducts } from "../../../apiclient/product/useGetProductApi";

interface IMonthlyDairySummaryReport { }

export const MonthlyDairySummaryReport: React.FC = () => {
    const [reportMenu, setReportMenu] = useState<IMonthlyDairySummaryReport[]>([]);
    const [productData, setProductData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedProduct } = useGetProducts();
    const [fromDate, setFromDate] = useState<Date>(
        new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
    );
    const [toDate, setToDate] = useState<Date>(new Date());
    useEffect(() => { }, [reportMenu]);
    

    useEffect(() => {
        if (fetchedProduct) {
            const mappedProduct = fetchedProduct.map((product: any) => ({
                value: product.productId,
                label: product.name,
            }));
            setProductData(mappedProduct);
        }


    }, [fetchedProduct]);

     // Initial values for Formik
  const initialValues = {
    productId: "", // default empty value for zone
    fromDate: fromDate,
    toDate: toDate,
  };
//   const hasRecords = gridData.length > 0; 

    // let grid = (
    //   <Grid
    //     data={null}
    //     pageable={{ pageSizes: [10, 20, 50, 100] }}
    //     total={null}
    //     groupable={true}
    //     sortable={true}
    //     onDataStateChange={null}
    //     onExpandChange={null}
    //     expandField="expanded"
    //     columnVirtualization={false}
    //   >
    //     <GridColumn
    //       width={"350px"}
    //       field="taxName"
    //       title="Name"
    //       columnMenu={null}
    //     />
    //     <GridColumn
    //       width={"250px"}
    //       field="cgstPercentage"
    //       title=" CGST(%)"
    //       columnMenu={null}
    //     />
    //     <GridColumn
    //       width={"250px"}
    //       field="sgstPercentage"
    //       title="SGST(%)"
    //       columnMenu={null}
    //     />
    //     <GridColumn width={"250px"} field="igstPercentage" title="IGST(%)" />

    //     <GridNoRecords>
    //       <div className="mt-2" style={{ width: "100%", height: "500px" }}>
    //         <center>
    //           <h5>No data found</h5>
    //         </center>
    //       </div>
    //     </GridNoRecords>
    //   </Grid>
    // );
    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                console.log("Form submitted with values: ", values);
            }}
        >
            {({ setFieldValue, values }) => (
                <Form>

                    <div
                        className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
                        style={{ minHeight: "500px" }}
                    >
                        <div className="top-sec-align row">
                            <center>
                                <h4 className="text-normal title-web mb-0 report-title-color">Monthly Dairy Summary</h4>
                            </center>
                        </div>
                        <div className="fade_rule"></div>
                        <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                            <div>
                                <label>Search</label>
                                <input
                                    type="text"
                                    className="form-control ms-auto search-right-align searchBg"
                                />
                            </div>
                            <div className="d-flex">
                                <div className="me-2">
                                    <label>From Date</label>
                                    <DatePicker
                                        selectsMultiple={true}
                                        openToDate={new Date()}
                                        className="form-control ms-auto search-right-align calendarBg"
                                        value={formatDate(fromDate, "dd/MM/yyyy")}
                                        placeholderText="To"
                                        dateFormat={"dd/MM/yyyy"}
                                        onChange={([date]: any) => {
                                            setFromDate(date);
                                        }}
                                    />
                                </div>
                                <div className="me-2">
                                    <label>To Date</label>
                                    <DatePicker
                                        selectsMultiple={true}
                                        openToDate={new Date()}
                                        className="form-control ms-auto search-right-align calendarBg"
                                        value={formatDate(toDate, "dd/MM/yyyy")}
                                        placeholderText="To"
                                        dateFormat={"dd/MM/yyyy"}
                                        onChange={([date]: any) => {
                                            setToDate(date);
                                        }}
                                    />
                                </div>
                                <div className="me-2">
                                <label>Select Product </label>

                                <SelectField
                                        name="productId" 
                                        options={productData}
                                        unSelectValue={0} 
                                    
                                    />
                                </div>
                                <div>
                                    <label></label>
                                    <button
                                        className="btn-primary btn search-btn mt-4"
                                        onClick={() => {
                                            // console.log(fromDateRef.current)
                                            // console.log(toDateRef.current)
                                        }}
                                        type="submit"
                                    >
                                        <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                                            <path
                                                id="Path_magnify"
                                                data-name="Path / magnify"
                                                d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                                                transform="translate(-3 -3)"
                                                fill="#fff"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row col=12">
                            <div>
                                <div className="top-sec-align row">
                                    <div className="d-flex justify-content-end">
                                        <button title="Export Excel" className="btn m-2" onClick={null}>
                                            Export to Excel
                                        </button>
                                        <button
                                            title="Refresh list"
                                            className="btn two m-2"
                                            onClick={() => { }}
                                        >
                                            Refresh
                                        </button>
                                    </div>
                                </div>
                                <LoadingIndicator isLoading={false} />
                                {/* <div> {grid}</div> */}
                            </div>
                        </div>
                    </div>
                </Form>
            )
            }
        </Formik >
    );
};
